// Olympiad and contest record.
//
// Previously one flat, undated list of 18 entries, which flattened an NWERC
// medal and a 2015 junior olympiad to the same visual weight. Each entry now
// carries a year and a category so the Achievements page can group them and
// lead with the strongest.

export const achievementItems = [
  // --- Informatics & competitive programming ---
  {
    name: 'Bronze Medal, Northwestern European Regional Contest (NWERC)',
    year: '2022',
    category: 'informatics',
    highlight: true,
  },
  {
    name: '538th, Meta Hacker Cup Round 2',
    year: '2022',
    category: 'informatics',
  },
  {
    name: 'Bronze Medal, Competencia Iberoamericana de Informática y Computación (CIIC)',
    year: '2021',
    category: 'informatics',
  },
  {
    name: '1017th, Google Code Jam Round 2',
    year: '2021',
    category: 'informatics',
  },
  {
    name: 'Bronze Medal, International Olympiad of Metropolises (Informatics)',
    year: '2020',
    category: 'informatics',
  },
  {
    name: 'Bronze Medal, Competencia Iberoamericana de Informática y Computación (CIIC)',
    year: '2020',
    category: 'informatics',
  },

  // --- Mathematics ---
  {
    name: 'Gold Medal, Ibero-American Olympiad of Mathematics',
    year: '2021',
    category: 'mathematics',
    highlight: true,
  },
  {
    name: 'Gold Medal, Cyberspace Mathematical Competition',
    year: '2020',
    category: 'mathematics',
    highlight: true,
  },
  {
    name: 'Bronze Medal, Asian Pacific Mathematical Olympiad',
    year: '2020',
    category: 'mathematics',
  },
  {
    name: 'Honourable Mention, Romanian Master of Mathematics',
    year: '2020',
    category: 'mathematics',
  },
  {
    name: 'Silver Medal, Olimpiada de Matemática del Cono Sur',
    year: '2019',
    category: 'mathematics',
  },
  {
    name: 'Honourable Mention, Geometrical Olympiad in Honour of I. F. Sharygin',
    year: '2019',
    category: 'mathematics',
  },
  {
    name: 'Gold Medal, Peruvian Olympiad of Mathematics',
    year: '2018, 2019',
    category: 'mathematics',
  },
  {
    name: 'Silver Medal, Olimpiada Matemática Rioplatense',
    year: '2018, 2019',
    category: 'mathematics',
  },
  {
    name: 'Gold Medal, Olimpiada de Mayo',
    year: '2018',
    category: 'mathematics',
  },
  {
    name: 'Gold Medal, Iranian Geometry Olympiad',
    year: '2016',
    category: 'mathematics',
  },
  {
    name: 'Silver Medal, Olimpiada de Mayo',
    year: '2016',
    category: 'mathematics',
  },
  {
    name: 'Bronze Medal, Olimpiada de Mayo',
    year: '2015',
    category: 'mathematics',
  },
];
